`<template>
  <div id="app">
    <nf-header v-show="!$route.meta.hideNfHead && JSON.stringify($route.meta) !== '{}'" />
    <router-view />
  </div>
</template>

<script>
import nfHeader from '@/components/nf-header/index';
import store from '@/store/index';
import { getCookie , setCookie} from '@/assets/cookie';
import Cookies from 'js-cookie';
export default {
  name: 'App',
  components: {
    nfHeader,
  },
  watch: {
    $route(data) {
      this.$store.commit(
        'uppdateNavMenuActive',
        data.meta.NavMenuActive ? data.meta.NavMenuActive : data.path,
      );
    },
  },
  mounted() {
    const ShippersUserInfo = getCookie('ShippersUserInfo')?JSON.parse(getCookie('ShippersUserInfo')):{}
    if (getCookie('unified-token')) {
      if(ShippersUserInfo) {
        console.log('来自统一端');
      }else {
        const params = { accessToken : getCookie('unified-token')} 
        const subdomain = this.getSubdomain(window.location.hostname);
        Cookies.set('ShippersUserInfo', JSON.stringify(params),{domain: subdomain});
      }
    }
    Promise.all([store.dispatch('getList')]).then(res => {
      if (res[0].code === 200) {
        store.dispatch('getCertify');
        store.dispatch('getAll');
        store.dispatch('getCompany');
        store.dispatch('getInfo');
        store.dispatch('getOptMarkStatus');
        store.dispatch('getAgentSMSValidate');
      }
    });
  },
  methods:{
    getSubdomain(hostname) {
      const parts = hostname.split('.');
      console.log(parts);
      if (parts.length > 2) {
        return '.'+parts[1]+'.'+ parts[2]; 
      }
      return ''; 
    }
  }
};
</script>

<style>
@import './assets/styles/reset.css';
@import './assets/styles/base.scss';
@import './assets/styles/resetStyle.css';
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
    '微软雅黑', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
html {
  min-width: 1440px;
  /* background: #0056FF; */
  background: #f0f2f5;
  height: 100%;
}
</style>
